<template>
  <!-- -->
  <div class="sale-order mini-component-show" :style="{'--component-height': `${data.height || '300'}px`}">
    <div class="title">
      <div class="my-order">我的订单</div>
      <div class="all">全部订单<yq-icon name="element-ui_arrow-right" /></div>
    </div>
    <div class="order-icon">
      <div class="icon-item" v-for="(item, idx) in dataList" :key="idx" :style="{'--text-color': item.textColor, '--text-background': item.textBackground, '--text-size': item.textSize}">
        <div class="icon-area"><yq-icon :name="item.itemIcon"/></div>
        <div class="icon-name">{{ item.text }}</div>
      </div>
    </div>
  </div>
</template>

<script>

import AloneImage from "@/views/h5/common/sys/miniProgram/setting/component/AloneImage.vue";
import {watch} from "vue";
import YqIcon from "@/components/YqIcon.vue";

export default {
  props: {
    data: {default: () => {
        return {}
      }},
  },
  name: "",
  components: {
    YqIcon,
    AloneImage
  },
  data() {
    return {
      dataList: [],
    };
  },
  created() {
    this.init();
    watch(() => this.data, () => this.init())
  },
  methods: {
    init() {
      if (!this.data.componentData || !this.data.componentData.length) {
        this.dataList = [
          {text: "待付款", itemIcon: "huiyuanqiagoumai", textColor: "rgba(255, 0, 0, 1)", textBackground: "rgba(255, 0, 0, 0.3)", path: "", textSize: "0.7567rem"},
          {text: "待发货", itemIcon: "shouhou", textColor: "rgba(0, 174, 255, 1)", textBackground: "rgba(0, 174, 255, 0.3)", path: "", textSize: "0.7567rem"},
          {text: "待收货", itemIcon: "element-ui_check", textColor: "rgba(106, 0, 255, 1)", textBackground: "rgba(106, 0, 255, 0.3)", path: "", textSize: "0.7567rem"},
          {text: "已完成", itemIcon: "element-ui_tickets", textColor: "rgba(255, 119, 0, 1)", textBackground: "rgba(255, 119, 0, 0.3)", path: "", textSize: "0.7567rem"},
        ];
      } else {
        this.dataList = this.data.componentData;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.sale-order{
  padding: 20px;
  .title{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .my-order{
      font-size: 28px;
    }
    .all{
      color: var(--yq-font-color-desc);
      font-size: 24px;
    }
  }
  .order-icon{
    display: flex;
    justify-content: space-between;
    padding: 20px 30px 0;
    .icon-item{
      text-align: center;
      .icon-area{
        width: 100px;
        aspect-ratio: 1/1;
        display: flex;
        justify-content: center;
        align-items: center;
        color: var(--text-color);
        background-color: var(--text-background);
        border-radius: 10px;
      }
      .icon-name{
        font-size: var(--text-size);
        color: var(--yq-font-color-desc);
        margin-top: 10px;
      }
    }
  }
}
</style>